<template>
  <div class="container p-5">
    <div class="row">
      <div class="col-12">
        <h4 class="text-center">BASES Y CONDICIONES</h4>
      </div>

      <div class="col-12">
        <h5><b>1. ORGANIZADOR DEL SORTEO</b></h5>
        <p>
          El presente sorteo es organizado y promovido por
          <b>FCA AUTOMOBILES ARGENTINA S.A.</b>, CUIT 30-71031554-6, con
          domicilio legal en Carlos María della Paolera 299, Ciudad Autónoma de
          Buenos Aires (en adelante, el "Organizador"). La mecánica, desarrollo
          y proceso de selección de los ganadores será responsabilidad exclusiva
          del Organizador. Una vez entregado el premio, el Organizador se
          deslinda de toda responsabilidad vinculada al uso y/o goce del mismo.
        </p>
        <p>
          Cualquier consulta relacionada con el sorteo podrá realizarse al
          WhatsApp +54 9 11 2689-0452 o al 0800 333 7070, de lunes a viernes, de
          8 a 20 hs
        </p>
      </div>

      <div class="col-12">
        <h5><b>2. BASES DE PARTICIPACIÓN</b></h5>
        <p>
          Estas Bases y Condiciones regulan el sorteo
          <b>“Jeep Nature – Esteros del Iberá”</b>. La participación en este
          sorteo implica el conocimiento y aceptación total de estas
          condiciones.
        </p>
      </div>

      <div class="col-12">
        <h5><b>3. ACEPTACIÓN DE LAS BASES DE LA PROMOCIÓN</b></h5>
        <p>
          La participación supone la aceptación plena, sin reservas, de todas
          las condiciones establecidas. Quien no esté de acuerdo con cualquiera
          de estas disposiciones no podrá participar. La participación es libre
          y gratuita, sin obligación de compra. La obtención del premio está
          sujeta al cumplimiento de los requisitos establecidos en el presente
          documento. Las decisiones del Organizador son definitivas e
          inapelables.
        </p>
      </div>

      <div class="col-12">
        <h5><b>4. CONDICIONES PARA SER PARTICIPANTE</b></h5>
        <p>
          Podrán participar personas mayores de 18 años, residentes en
          Argentina, que sean titulares de un vehículo de la marca Jeep y estén
          registrados en el programa Jeep WAVE.
        </p>
      </div>

      <div class="col-12">
        <h5><b>5. MECÁNICA DE PARTICIPACIÓN</b></h5>
        <p>
          Quedará comprendido como participante todo titular de un vehículo Jeep
          que se registre en la plataforma Jeep WAVE entre el 23 de abril de
          2025 (00:00 h) y el 12 de mayo de 2025 (23:59 h), aceptando
          expresamente las Bases y Condiciones del presente sorteo
        </p>
      </div>

      <div class="col-12">
        <h5><b>6. PREMIOS</b></h5>
        <p>
          Se sortearán cinco (5) experiencias “Jeep Nature – Esteros del Iberá”,
          cada una válida para el ganador y un (1) acompañante mayor de edad.
        </p>
        <p>Cada experiencia incluye:</p>
        <ul>
          <li>
            Traslado desde el aeropuerto de Resistencia hacia el punto de la
            actividad
          </li>
          <li>Vehículo Jeep asignado para las actividades</li>
          <li>
            Alojamiento por una (1) noche en el ecolodge “Rincón del Socorro”.
          </li>
          <li>Cuatro (4) comidas diarias por persona.</li>
          <li>
            Actividades incluidas: safari 4x4, cabalgatas, navegación, y
            masterclass gastronómica.
          </li>
        </ul>
        <p>
          Los premios son personales e intransferibles, y no podrán canjearse
          por dinero en efectivo ni por otros productos o servicios. Toda
          prestación adicional que no esté expresamente mencionada correrá por
          cuenta exclusiva del ganador.
        </p>
      </div>

      <div class="col-12">
        <h5><b>7. MODALIDAD DE SORTEO</b></h5>
        <p>
          El sorteo se realizará el 13 de mayo de 2025 mediante una plataforma
          digital automática.
        </p>
        <p>
          Se verificarán previamente las condiciones de participación. Si se
          detecta algún incumplimiento, se descalificará automáticamente al
          participante y se seleccionará un nuevo ganador.
        </p>
      </div>

      <div class="col-12">
        <h5><b>8. ANUNCIO DE GANADORES Y ENTREGA DEL PREMIO</b></h5>
        <p>
          Los ganadores serán anunciados el 14 de mayo de 2025 a través de la
          plataforma Jeep WAVE y serán notificados por correo electrónico al
          mail registrado.
        </p>
        <p>
          El ganador deberá confirmar su aceptación y disponibilidad para la
          experiencia. En caso de no responder en el plazo que el Organizador
          determine, el premio se considerará vacante y se podrá reasignar.
        </p>
      </div>

      <div class="col-12">
        <h5>
          <b> 9. AUTORIZACIÓN DE USO DE IMAGEN </b>
        </h5>
        <p>
          Al participar, los ganadores autorizan al Organizador a utilizar su
          nombre, imagen, voz y demás datos personales para difusión con fines
          promocionales, en los medios y formas que el Organizador considere
          pertinentes, por un plazo de hasta tres (3) años, sin derecho a
          compensación alguna.
        </p>
      </div>

      <div class="col-12">
        <h5>
          <b> 10. PROTECCIÓN DE DATOS PERSONALES </b>
        </h5>
        <p>
          Los datos personales recabados serán tratados conforme a la Ley de
          Protección de Datos Personales N° 25.326, exclusivamente con fines
          promocionales y administrativos relacionados al sorteo y al programa
          Jeep WAVE.
        </p>
      </div>

      <div class="col-12">
        <h5>
          <b> 11. MODIFICACIÓN DE LAS CONDICIONES </b>
        </h5>
        <p>
          El Organizador se reserva el derecho de modificar total o parcialmente
          estas bases hasta 5 horas antes del cierre del sorteo, o cancelar el
          mismo en caso de fuerza mayor. Cualquier modificación será debidamente
          comunicada por los canales oficiales de la plataforma Jeep WAVE.
        </p>
      </div>

      <div class="col-12">
        <h5>
          <b> 12. GASTOS ADICIONALES </b>
        </h5>
        <p>
          Todo gasto no previsto expresamente en estas Bases correrá por cuenta
          exclusiva de los participantes. Esto incluye, entre otros: gastos
          personales, traslados al aeropuerto, seguros médicos o equipamiento
          adicional.
        </p>
      </div>

      <div class="col-12">
        <h5>
          <b> 13. LEY APLICABLE Y JURISDICCIÓN </b>
        </h5>
        <p>
          Toda controversia derivada del presente sorteo será resuelta conforme
          a la legislación de la República Argentina, sometiéndose las partes a
          la jurisdicción de los tribunales ordinarios con competencia en la
          Ciudad Autónoma de Buenos Aires.
        </p>
      </div>
    </div>
  </div>
</template>
